<mot-button [buttonClass]="menuButtonClass ?? buttonClass" [icon]="!!menuVert ? 'ellipsis-vertical' : 'ellipsis'"
  [matMenuTriggerFor]="!!menuItems && menuItems.length ? menu : null" [ariaLabel]="menuButtonAriaLabel"
  [ariaHaspopup]="'menu'" [ariaExpanded]="isMenuOpen"
  (menuOpened)="onMenuOpened(); menuButtonClass = buttonActiveClass ?? buttonClass" (menuClosed)="onMenuClosed()"
  iconClass="text-[2rem]" />

  <mat-menu #menu="matMenu" [xPosition]="menuPositionX" hasBackdrop="true" backdropClass="menu-overlay"
    [class]="heightClass" class="!rounded-xl">
    <!-- mat-menu-item registers with MatMenu FocusKeyManager; mot-button inside was not reachable by Tab/Arrow keys. -->
    <div class="flex flex-col w-60 items-stretch" [class]="menuClass" [dir]="direction">
      @for (menuItem of menuItems; track menuItem) {
        <button mat-menu-item type="button" [disabled]="!!menuItem.disabled"
          [attr.aria-label]="menuItem.ariaLabel || menuItem.label" [attr.aria-haspopup]="menuItem.ariaHaspopup || null"
          class="!min-h-12 !rounded-none !justify-start w-full flex items-center gap-2 text-start hover:!bg-gray-100"
          [ngClass]="menuItemClass" (click)="handleMenuItemClick($event, menuItem)">
          <div class="flex items-center gap-2">
            @if (menuItem.icon) {
              <ng-icon [name]="menuItem.icon" class="text-2xl shrink-0" aria-hidden="true" />
            }
            <span class="min-w-0 flex-1">{{ menuItem.label }}</span>
          </div>
        </button>
      }

      <div class="menu-item w-full">
        <ng-content />
      </div>
    </div>

  </mat-menu>